export enum MonitoringAttributes {
  USER = "user",
  ACCOUNT = "account",
  CUSTOMER = "customer"
}
